const api = require('./../../../../../global/js/modules/api');
const VueUtils = require('../../../modules/vue-utils');

let $launchpad,
    $searchForm, $searchButton, $token,
    $reservationCode, $reservationSurname,
    $searchResultsContainer,
    $locationName, $from, $to,
    $tabButton,
    $dialog
;

//booking-launchpad

function _message(message) {
    $dialog = VueUtils.getRef('modal-dialog');
    return $dialog.setContent(message, true);
}

function _confirm(message, okLabel = 'OK', cancelLabel = 'CANCEL') {
    $dialog = VueUtils.getRef('modal-dialog');
    $dialog.showCancel();
    $dialog.setCancelLabel(cancelLabel);
    $dialog.setOkLabel(okLabel);
    return $dialog.setContent(message, true);
}

function _search() {
    //catch when someone presses enter in a field
    if ($searchButton.disabled) {
        return;
    }

    const $codeFields = $searchResultsContainer.querySelectorAll('input[name=reservation_code]'),
        $surnameFields = $searchResultsContainer.querySelectorAll('input[name=reservation_surname]');

    for (let $fields of [$codeFields, $surnameFields]) {
        for (let $field of $fields) {
            $field.value = '';
        }
    }

    let code, surname;

    code = $reservationCode.value.trim();
    surname = $reservationSurname.value.trim();

    if (!code || !surname) {
        _message('Please enter code and surname');
        return false;
    }

    $searchButton.disabled = true;
    $searchResultsContainer.classList.add('hidden');

    api.local.searchForBooking({code, surname, _token: $token.value})
        .then(response => {
            console.info('found booking', response);

            if (!response.booking.cancellable) {
                _message('Booking found, but is not able to be modified.');
            }
            else {

                for (let $field of $codeFields) {
                    $field.value = code;
                }

                for (let $field of $surnameFields) {
                    $field.value = surname;
                }

                $locationName.innerText = response.booking.pickup_location.name;
                $from.innerText = response.booking.from_date.replace(/:0+\.0+/, '');
                $to.innerText = response.booking.to_date.replace(/:0+\.0+/, '');

                $searchResultsContainer.classList.remove('hidden');
            }
        }, response => {
            console.error('Failed to find booking', response);
            _message('Error retrieving booking. Please ensure details are correct and try again');
        })
        .finally(() => {
            $searchButton.disabled = false;
        })
    ;


    let $cancelForm = $searchResultsContainer.querySelector('form.cancel-booking');

    if ($cancelForm) {
        $cancelForm.querySelector('input[type=submit]').addEventListener('click', e => {
            e.stopImmediatePropagation();
            e.preventDefault();

            _confirm('Are you sure you wish to cancel this booking?', 'YES', 'NO')
                .then(() => {
                    $cancelForm.submit();
                }, () => {

                });

            return false;
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    $launchpad = document.querySelector('#booking-launchpad');

    if (!$launchpad) {
        return;
    }

    $token = document.querySelector('input[name=_token]');

    $searchForm = $launchpad.querySelector('.reservationForm');
    $reservationCode = $launchpad.querySelector('input[name=reservation_code]');
    $reservationSurname = $launchpad.querySelector('input[name=reservation_surname]');
    $searchResultsContainer = $launchpad.querySelector('.booking-search-results');
    $searchButton = $searchForm.querySelector('input[type=submit]');

    if (!$searchForm || !$reservationCode || !$reservationSurname || !$searchResultsContainer || !$token) {
        throw 'Found launchpad, but could not find required elements';
    }

    $locationName = $searchResultsContainer.querySelector('.pickup-text');
    $from = $searchResultsContainer.querySelector('.from-text');
    $to = $searchResultsContainer.querySelector('.to-text');

    if (!$locationName || !$from || !$to) {
        throw 'Found launchpad, but could not find required location elements';
    }

    $tabButton = document.querySelector('.tabButton--reservation');

    if (!$tabButton) {
        //invisible button...
        $tabButton = document.createElement('button');
    }

    $searchForm.addEventListener('submit', event => {
        event.stopImmediatePropagation();
        event.preventDefault();

        _search();

        return false;
    });



    if ($reservationCode.value !== '' || $reservationSurname.value !== '') {
        console.info('clicking button');
        $tabButton.click();
    }

    if ($reservationCode.value !== '' && $reservationSurname.value !== '') {
        _search();
    }


});